<template>
  <div>
    <v-card>
      <v-card-subtitle class="d-flex align-center">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('Search')"
          single-line
          hide-details
        />
        <v-btn
          class="ml-4"
          color="secondary"
          @click="exportLaboratoriesTable"
        >
          {{ $t('export') }}
        </v-btn>
      </v-card-subtitle>

      <v-data-table
        :headers="headers"
        :items="laboratories || []"
        :search="search"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        calculate-widths
        :custom-filter="customFilter"
        @click:row="onClickOnLaboratory"
      >
        <!--        <template v-for="lang in languages">-->
        <!--        </template>-->

        <template v-slot:item.levelOfServices="{ item }">
          <v-chip
            v-for="service in levelOfServicesForDataTable(item)"
            :key="service"
            class="mr-1 my-1"
          >
            {{ service }}
          </v-chip>
        </template>

        <template v-slot:item.childLaboratories="{ item }">
          <template v-if="item.childLaboratories.length">
            <span
              v-for="(lab, index) in item.childLaboratories"
              :key="lab.id"
            >
              <template v-if="index > 0">, </template>
              {{ lab.name }}
            </span>
          </template>
          <template v-else>
            -
          </template>
        </template>

        <template v-slot:item.parentLaboratory="{ item }">
          <template v-if="item.parentLaboratory">
            {{ item.parentLaboratory.name }}
          </template>
          <template v-else>
            -
          </template>
        </template>

        <template v-slot:item.manager="{ item }">
          <span v-if="item.manager">
            {{ item.manager.firstName }} {{ item.manager.lastName }}
          </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>

import {export_json_to_excel_custom} from "@/vendor/Export2Excel";

export default {
  name: "AdministrationLaboratories",

  props: {
    laboratories: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      sortBy: 'id',
      sortDesc: false,
      search: ''
    }
  },

  computed: {
    headers() {
      let headers = [
        {
          text: this.$t('Id'),
          value: 'id',
          align: 'start',
          sortable: true,
        },
        {
          text: this.$t('Name'),
          value: 'name',
          align: 'start',
          sortable: true,
        },
        {
          text: this.$t('Description'),
          value: 'description',
          align: 'start',
          sortable: false,
          filterable: false,
        },
        {
          text: this.$t('Address'),
          value: 'address',
          align: 'start',
          sortable: false,
          filterable: false,
        },
        {
          text: this.$t('Telephone'),
          value: 'telephone',
          align: 'start',
          sortable: false,
          filterable: false,
        },
        {
          text: this.$t('Manager'),
          value: 'manager',
          align: 'start',
          sortable: false,
        },
        {
          text: this.$t('Coordinates'),
          value: 'coordinates',
          align: 'start',
          sortable: false,
        },
        // {
        //     text: 'Country',
        //     value: 'country.name',
        //     align: 'start',
        //     sortable: true,
        // },
        {
          text: this.$t('Type'),
          value: 'laboratoriesType.name',
          align: 'start',
          sortable: true,
        },
        {
          text: this.$t('Scope of services'),
          value: 'levelOfServices',
          align: 'start',
          sortable: true,
        },
        {
          text: this.$t('Peripheral lab'),
          value: 'childLaboratories',
          align: 'start',
          sortable: true,
        },
        {
          text: this.$t('Central/Reference lab'),
          value: 'parentLaboratory',
          align: 'start',
          sortable: true,
        },
        {
          text: this.$t('Users'),
          value: 'users.length',
          align: 'start',
          sortable: true,
          filterable: false,
        }
      ];

      headers.forEach(e => {
        e.class = 'text-no-wrap'
      });

      return headers
    },
  },

  methods: {
    levelOfServicesForDataTable(lab) {
      return lab.levelOfServices ? lab.levelOfServices.split(', ') : []
    },

    onClickOnLaboratory(item) {
      this.$router.push({name: 'Laboratory', params: {laboratoryId: item.id}})
    },

    customFilter(value, search) {

      if (value != null && search != null && typeof value !== 'boolean') {
        if (typeof value == 'object' && 'name' in value) {
          return value.name.toLowerCase().includes(search.toLowerCase())
        } else if (Array.isArray(value)) {
          return value.some(e => e.name.toLowerCase().includes(search.toLowerCase()))
        }
        return value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1
      }
      return false
    },

    exportLaboratoriesTable() {
      let multiData = [];


      {
        const tHeader = [
          '#', 'Id', 'Name', 'Description', 'Address', 'Telephone', 'Manager', 'Coordinates', 'Laboratories Type', 'Level Of Services', 'Peripheral lab', 'Central/Reference lab', 'Users'
        ];


        const filterVal = [
          '#', 'id', 'name', 'description', 'address', 'telephone', 'manager', 'coordinates', 'laboratoriesType', 'levelOfServices', 'childLaboratories', 'parentLaboratory', 'users'
        ];

        const deepValues = {
          manager(item) {
            return item?.manager ? (item?.manager?.firstName + ' ' + item?.manager?.lastName) : ''
          },
          laboratoriesType(item) {
            return item?.laboratoriesType?.name || ''
          },
          childLaboratories(item) {
            return item?.childLaboratories?.map(l => l.name).join(', ') || ''
          },
          parentLaboratory(item) {
            return item?.parentLaboratory?.name || ''
          },
          users(item) {
            return item?.users?.length || 0
          }
        };

        let data = this.laboratories.map((v, index) => {
          return filterVal.map(j => {
            if (j === '#') return index + 1;
            if (v[j]) {
              if (j in deepValues) {
                return deepValues[j](v)
              } else {
                return v[j].toString()
              }
            }

            return ''
          });
        }).filter(e => e);

        multiData.push({name: 'Laboratories', header: tHeader, data})
      }

      export_json_to_excel_custom({
        multiData,
        filename: 'Laboratories',
        autoWidth: true,
      })

    }
  },

}
</script>

<style lang="scss" scoped>
.v-data-table {
  ::v-deep td {
    cursor: pointer;
  }
}
</style>
